<template>
    <div class="page-revision-entry" :class="{'current':isCurrent}">
        <div class="layout-column">
	        <span class="__title">{{desc}}</span>

	        <span class="__updated-at" v-if="revision && !isCurrent">{{formatDate(revision.revision_created_at)}}</span>
	        <span class="__updated-at" v-else-if="isCurrent">{{formatDate(page.updated_at)}}</span>

        </div>
	    <div class="flex">

	    </div>
	    <div class="layout-row flex-center " >
		    <v-button small v-tippy="{theme:'small-black'}" content="Preview" :href="pagePreviewUrl"
		              :icon="require('@/assets/icons/preview.svg')"
		              flat target="_blank">
		    </v-button>
		    <div class="__sep" ></div>
		    <quick-actions-btn :disabled="isCurrent" @itemClick="itemClick" content="More actions"
		                       :items="[{label:'Restore...',icon:require('@/assets/img/go_back_arrow-ex.svg')}]"/>

	    </div>

      <portal to="popup" v-if="restoreOpen">
        <restore-page-revision-popup :revision="revision"
                           @close="restoreOpen=false" @done="restored=true;restoreOpen=false;$emit('restored',revision)" />
      </portal>

    </div>
</template>

<script>
import VButton from "@/components/base/v-button";
import RestorePageRevisionPopup from "@/views/funnels/funnel-plus/steps/restore-page-revision-popup";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
const moment = require('moment-timezone');

export default {
  name: 'PageRevisionEntry', components: {QuickActionsBtn, RestorePageRevisionPopup, VButton},
	props:{
	  revision:{},
	  isCurrent:{
			type:Boolean,
		  default:()=>false,
	  },
	  page:{}
  },
	data(){
		return {
			restored:false,
			restoreOpen:false,
		}
	},
	computed:{
		pagePreviewUrl() {
			let s = `https://${this.page.url}?preview=${this.page.id}`;
			if (!this.isCurrent) s += `&revision=${this.revision.id}`;
			return s;
		},
		desc() {
			if (this.isCurrent)
				return "Current version";
			else if (this.revision.revision_reason==="page_updated")
				return "Page updated";
			else if (this.revision.revision_reason==="revision_restored")
				return "Revision restored";
			else
				return this.revision.revision_description;
		}
	},
	methods:{
		itemClick(ev) {
			if (ev.action==='Preview') {
				window.open(this.pagePreviewUrl,'_blank')
			} else if (ev.action==='Restore...') {
				this.restoreOpen = true;
			}
		},
		formatDate(date){
			return moment(date).format("DD MMMM YYYY, HH:mm:ss")
		},
	}
};
</script>
<style lang="scss" scoped>
.page-revision-entry {
	display: flex;
	border: 1px solid $light-grey;
	padding: 10px 10px;
	border-radius: 3px;
	.__sep {
		background: $grey;
		width: 1px;
		height: 24px;
		margin: 1px 5px;
	}
	&:hover:not(.current) {
		background: #fafafa;
		border-color: #cfd0d9;
	}
	.__title {
		font-weight: 600;
		font-size: 14px;
		margin-bottom: 10px;
	}
	.__updated-at {
		font-weight: 500;
		font-size: 13px;
	}
	&.current {
		background: $light-silver;
	}
	.__restore_btn {
		border: 1px solid $grey;
		color: #434244;
	}
}

</style>
